<form [formGroup]="formGroup">
  <label for="folderId"><h4><mat-icon>description</mat-icon>&nbsp;Agiris / Isacompta / Isagri</h4></label>
  <mat-form-field>
    <mat-label>Identifiant dossier</mat-label>
    <input matInput formControlName="folderId" placeholder="000001">
  </mat-form-field>
  <app-basic-load-configuration-options
    [formGroup]="formGroup"
    [configuration]="configuration"
    [configurationMode]="configurationMode">
  </app-basic-load-configuration-options>
</form>

<h4><mat-icon>help</mat-icon>&nbsp;Documentation</h4>
<a href="{{documentationImportUrl}}" target="_blank">Comment importer un fichier DEX dans mon logiciel comptable ?</a>